module.exports = __webpack_public_path__ + "static/media/ShadowsIntoLight-Regular.47c22e0a.ttf";